import StorageService from './StorageService'
import BenutzerprofilDto from '../views/Authorization/BenutzerprofilDto'

export default class BerechtigungUtil {

  constructor() {
    this.backendUrl = ''
    this.storageService = new StorageService()
  }

  retrieveBackendUrl() {
    return fetch('./config/config.json', {cache: 'reload'})
      .then(res => res.json())
      .then(config => {
        this.backendUrl = `${config.backendUrl}/berechtigung`
      })
  }

  async refreshUserProfiles() {
    await this.retrieveBackendUrl()

    return fetch(this.backendUrl, {
      method: 'GET',
      cache: 'reload',
      headers: {
        'Authorization': 'Bearer ' + window.keycloak.token,
        'Content-Type': 'application/json'
      }
    }).then(res => res.json()
    ).then(json => {
      const profiles = json.map(p => new BenutzerprofilDto(p))
      window.profiles = profiles
      this.initActiveProfile(profiles)
      return profiles
    })
  }

  initActiveProfile = profiles => {
    // verify/initialize activeProfile
    let activeProfile = this.getActiveProfile()
    if (activeProfile && !profiles.some(p => p.uuid === activeProfile.uuid)) {
      // profile is no longer available
      activeProfile = null
      this.setActiveProfile(activeProfile)
    }
    if(!activeProfile && profiles.length > 0) {
      // set default profile
      this.setActiveProfile(profiles[0])
    }
  }

  getUserProfiles() {
    return window.profiles ?? []
  }

  getActiveProfile() {
    return this.storageService.get(StorageService.KEYS.ACTIVE_PROFILE, null)
  }

  setActiveProfile(profile) {
    return this.storageService.set(StorageService.KEYS.ACTIVE_PROFILE, profile)
  }

  async reloadProfile() {
    const activeProfile = this.getActiveProfile()
    const profiles = await this.refreshUserProfiles()
    this.setActiveProfile(profiles.find(p => p.uuid === activeProfile.uuid))
    window.location.reload()
  }

}
